import React from "react";
import { Container, Box, Typography } from "@mui/material";

/**
 * MesseScreenHR
 * Zeigt eine Überschrift, eine kurze Beschreibung und ein Video,
 * das sich unbegrenzt wiederholt.
 *
 * 👉  Ersetze den Platzhalter `videoUrl` unten durch den tatsächlichen Pfad
 *     zu deinem Video (z. B. aus dem `public`‑Ordner oder einem CDN).
 */
export default function MesseScreenHR() {
    const videoUrl = "/video/heyRobin_Scanner_mitLOGo_klein.mp4"; // TODO: anpassen

    return (
        <Container maxWidth="md" sx={{ py: 6 }}>
            <Box textAlign="center">
                {/* Überschrift */}
                <Typography variant="h3" component="h1" gutterBottom>
                    heyRobin VO-Checker
                </Typography>

                {/* Kurze Beschreibung */}
                <Typography variant="subtitle1" paragraph>
                    Scanne deine Verordnung direkt an unserem Scanner und nutze den heyRobin Verordnungs-Checker.
                    Deine Verordnung wird automatisch auf Vollständigkeit und formale Fehler geprüft – noch bevor sie eingereicht wird. So kannst du Absetzungen durch die Krankenkasse vermeiden, bevor sie überhaupt entstehen.
                </Typography>

                {/* Video in Endlosschleife */}
                <Box sx={{ mt: 4 }}>
                    <video
                        src={videoUrl}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{ width: "100%", maxWidth: 960, borderRadius: 12 }}
                    />
                </Box>
            </Box>
        </Container>
    );
}
